export default "__VITE_ASSET__1ad9567d__"